<!-- 25.02 精简样式卡片 -->
<template>
  <div
    class="b_item_box_v2"
    :class="{
      style_2: !isNoBuyStatus,
    }"
    @click="goDetailed(item)"
  >
    <div class="icon_box">
      <img v-lazy="item.iconUrl" class="icon_img" alt="benefit" />
      <img
        v-if="isNoBuyStatus"
        class="icon_lock"
        src="https://img0.didiglobal.com/static/soda_public/do1_FVluH56sfUBQdyQDMTU2"
        alt="lock"
      />
    </div>
    <div class="info_box">
      <h5 class="hyphenate-text">{{ item.title }}</h5>
      <!-- 操作 -->
      <template v-if="!isNoBuyStatus">
        <div v-if="item.receiveStatus === 0" class="btn" @click.stop="goSettingBir">
          {{ $t('FoodC_birthday_MdbO_KlNx') }}
        </div>
        <div v-if="item.receiveStatus === 1" class="btn" @click.stop="getBirthdayCoupons">
          {{ $t('FoodC_birthday_hJRO_UaMS') }}
        </div>
        <div v-if="foodOpen && item.receiveStatus === 3" class="btn" @click.stop="goCoupons">
          {{ $t('FoodC_birthday_vcey_tequ') }}
        </div>
        <div v-if="item.clickUrl" class="btn" @click.stop="jumpBenefit(item)">
          {{ jumpBtnName(item) }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import mixin from '@/page/member/mixins.js'

export default {
  name: 'MemberBenefitItemV2',
  mixins: [mixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goSettingBir() {
      this.$emit('goSettingBir')
    },
    getBirthdayCoupons() {
      this.$emit('getBirthdayCoupons')
    },
    goCoupons() {
      this.$emit('goCoupons')
    },
    goDetailed(data) {
      this.$emit('goDetailed', data)
    },
    jumpBenefit(data) {
      this.$emit('jumpBenefit', data)
    },
    jumpBtnName(data) {
      if (data.clickUrl) {
        return this.$t('FoodC_url_reaV_LXaO')
      }
      return this.$t('FoodC_shoprank_Qwab_yWBb')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

.b_item_box_v2 {
  margin-bottom: 20px;
  padding-bottom: 20px;
  width: 333px;
  // height: 224px;
  background: #f5f5f7;
  border-radius: 40px;
  &.style_2 {
    // height: 368px;
    // position: relative;
    .btn {
      // position: absolute;
      // bottom: 20px;
      box-sizing: border-box;
      margin-top: 8px;
      display: inline-block;
      padding: 4px 20px;
      text-align: center;
      background: #ffe5d9;
      border-radius: 25px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 24px;
      color: #ff5f14;
      line-height: 36px;
      font-weight: normal;
      min-width: 190px;
      max-width: 268px;
      @include ellipsis(1);
    }
  }
  .icon_box {
    position: relative;
    .icon_img {
      padding-left: 32px;
      padding-top: 16px;
      width: 100px;
      height: 100px;
    }
    .icon_lock {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 32px;
      height: 32px;
    }
  }
  .info_box {
    padding: 0 32px;
    padding-top: 12px;
    h5 {
      margin-bottom: 12px;
      font-family: DiDiSans-Pro-ExtraBoldTest;
      font-size: 24px;
      color: #0b0b0d;
      line-height: 32px;
      font-weight: normal;
      @include ellipsis(2);
    }
  }
}
</style>
